<div>
  @if (canOrders()) {
    <div class="d-inline-block nav-item temp-nav-icon position-relative quick">
      <span [routerLink]="['/warenkorb']"
        routerLinkActive="navLinkActive"
        routerLinkActiveOptions="{exact:true}"
        class="nav-link py-0"
        role="button"
        (click)="trackingEvent('Zum Warenkorb')">
        <mat-icon matBadge="{{(totals$ | async)?.quantityTotal || 0}}"
          matBadgeSize="medium"
          [matBadgeHidden]="((totals$ | async)?.quantityTotal || 0) == 0"
          [attr.data-cy]="'quick-nav-go-to-cart'"
        matTooltip="Zum Warenkorb" aria-hidden="false">shopping_cart</mat-icon>
      </span>
      <add-to-cart-notifier
        [cartItems]="(cartItems$ | async)"
        [latestItems]="(latestItems$ | async)"
        [addEventId]="(addToCartEvents$ | async)"></add-to-cart-notifier>
    </div>
  }
  @if (isOwner()) {
    <div class="d-inline-block dropdown nav-item temp-nav-icon">
      <span  class="nav-link dropdown-toggle pt-3 px-3" role="button" data-toggle="dropdown" aria-expanded="false">
        <span class="material-symbols-outlined">settings</span>
      </span>
      <div class="dropdown-menu">
        <a [routerLink]="['/mitbenutzerverwaltung']" class=" quick dropdown-item py-xxs" (click)="trackClick('NAVIGATION.PREFERENCES.SUBUSERMANAGEMENT.LINK')">
          <span>{{ 'NAVIGATION.PREFERENCES.SUBUSERMANAGEMENT.LINK' | translate }}</span>
        </a>
        <a [routerLink]="['/schnittstellen']" class="quick dropdown-item py-xxs" (click)="trackClick('NAVIGATION.PREFERENCES.INTEGRATIONS.LINK')">
          <span>{{ 'NAVIGATION.PREFERENCES.INTEGRATIONS.LINK' | translate }}</span>
        </a>
        <a [routerLink]="['/benachrichtigungen']" class="quick dropdown-item py-xxs" (click)="trackClick('NAVIGATION.PREFERENCES.COMMUNICATIONS.LINK')">
          <span>{{ 'NAVIGATION.PREFERENCES.COMMUNICATIONS.LINK' | translate }}</span>
        </a>
      </div>
    </div>
  }
</div>

